module.exports = __webpack_public_path__ + "static/go-voyayge-d62fb729876c67ce2248a58305918272.png";